import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Collapse,
  Alert,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSaveFinancialCategory } from './hooks/useSaveFinancialCategory';

export default function FinancialCategoryFormModal({
  open,
  onClose,
  onSave,
  basePath,
  category,
  entityLabel,
}) {
  const navigate = useNavigate();
  const { save: saveCategory } = useSaveFinancialCategory(basePath);
  const [formDescription, setFormDescription] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setFormDescription(category?.description ?? '');
      setError('');
    }
  }, [open, category]);

  const save = () => {
    if (!formDescription.trim()) return;

    const payload = {
      description: formDescription,
    };

    saveCategory(category ? category.id : null, payload)
      .then(() => {
        onSave();
        onClose();
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          navigate('/expired-session');
        } else {
          setError(err.response?.data ?? 'Erro ao salvar categoria.');
        }
      });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 'bold' }}>
        {category ? `Editar ${entityLabel}` : `Nova ${entityLabel}`}
      </DialogTitle>
      <DialogContent>
        <Collapse in={!!error} sx={{ mb: 1 }}>
          <Alert severity="error" onClose={() => setError('')}>
            {error}
          </Alert>
        </Collapse>
        <TextField
          autoFocus
          label="Descrição"
          fullWidth
          value={formDescription}
          onChange={(e) => setFormDescription(e.target.value)}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" onClick={save} disabled={!formDescription.trim()}>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

FinancialCategoryFormModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  basePath: PropTypes.string.isRequired,
  entityLabel: PropTypes.string.isRequired,
  category: PropTypes.shape({
    id: PropTypes.number,
    description: PropTypes.string,
  }),
};

FinancialCategoryFormModal.defaultProps = {
  category: null,
};
